import React from 'react';
import ReactLoading from 'react-loading';
 

/* 
export const list = [
  { prop: "balls",name: "Balls" },
  { prop: "bars", name: "Bars" },
  { prop: "bubbles", name: "Bubbles" },
  { prop: "cubes", name: "Cubes" },
  { prop: "cylon", name: "Cylon" },
  { prop: "spin", name: "Spin" },
  { prop: "spinningBubbles", name: "SpinningBubbles" },
  { prop: "spokes", name: "Spokes" }
];
*/

const EngagingLoader = ({ type, color }) => (
    <div className={`flex items-center justify-center h-screen`}  >
        <ReactLoading type={type} color={color}   />
    </div>
);
 
export default EngagingLoader;